import { OrdersOpenOrderAmounts } from "@springtree/eva-services-core/lib/eva-services-core";

import { GuestTrackOrderSummary } from "~/shared/guest-track-order/guest-track-order-summary";

export function normaliseGuestTrackOrderSummary(response: GuestTrackOrderSummary) {
  const orderDetail = response.orderDetail;
  const order = orderDetail.Result;
  const products =
    order?.Lines?.filter(
      (line) => !!line.ProductID && ((line.IsCancelled && line.FulfillmentStatus === 800) || !line.IsCancelled)
    ) ?? [];
  const cancelledLines = products.filter((line) => line.IsCancelled) || [];
  const shipments = response.shipments?.Result ?? [];
  const blobs = response.blobs?.Result ?? [];
  const invoiceBlob = blobs.find((blob) => blob.Type == 1) ?? null;
  const returnableStatuses = response.returnableStatus?.Result ?? [];
  const organizationUnit = response.organizationUnit ?? null;

  return {
    blobs,
    loyalty: response.loyalty,
    order,
    products,
    cancelledLines,
    amounts: orderDetail.Amounts || ({} as OrdersOpenOrderAmounts),
    additionalOrderData: orderDetail.AdditionalOrderData,
    giftcards: response.giftcards ?? [],
    shipmentTracking: shipments[0] ?? null,
    invoiceBlob,
    prefigureDiscounts: response.prefigureDiscounts,
    returnableStatuses,
    returnAvailable: returnableStatuses.some((line) => line.IsReturnable),
    originatingOrgCountryCode: organizationUnit?.Address?.CountryID ?? organizationUnit?.CountryID ?? null,
  };
}
